import { Icons } from '../utils/Icons.js';

export default class LeaderboardManager {
    constructor(engine) {
        this.engine = engine;
        this.ui = {
            screen: document.getElementById('leaderboard-screen'),
            list: document.getElementById('leaderboard-list'),
            backBtn: document.getElementById('leaderboard-back-btn'),
            search: document.getElementById('leaderboard-search'),
        };

        if (this.ui.backBtn) {
            this.ui.backBtn.addEventListener('click', () => this.hideMenu());
        }

        if (this.ui.search) {
            this.ui.search.addEventListener('input', (e) => this.filterLeaderboard(e.target.value));
        }
    }

    async getHighScores(key) {
        // Pure API
        const scores = await this.engine.authManager.db.getLeaderboard(key);
        return scores || [];
    }

    async checkHighScore(key, score) {
        const scores = await this.getHighScores(key);
        if (scores.length < 10) return true;
        return score > scores[scores.length - 1].score;
    }

    showMenu(gamesList) {
        this.engine.ui.menu.classList.add('hidden');
        this.engine.ui.menu.classList.remove('active');

        if (this.ui.screen) {
            this.ui.screen.classList.remove('hidden');
            this.ui.screen.classList.add('active');
            this.renderGameList(gamesList);
        }
    }

    hideMenu() {
        if (this.ui.screen) {
            this.ui.screen.classList.add('hidden');
            this.ui.screen.classList.remove('active');
        }
        this.engine.ui.menu.classList.remove('hidden');
        this.engine.ui.menu.classList.add('active');
    }

    renderGameList(gamesList) {
        if (!this.ui.list) return;
        this.ui.list.innerHTML = '';
        this.ui.list.style.display = 'grid';
        this.ui.list.style.gridTemplateColumns = 'repeat(auto-fill, minmax(100px, 1fr))';
        this.ui.list.style.gap = '10px';

        // 1. GLOBAL LEVELS (icône barres = classement, pas une coupe)
        this.createCard(this.engine.i18n.t('leaderboard.globalRank'), 'level', {
            leadIconHtml: Icons.leaderboardBars(24, 'var(--accent-color)'),
        });

        // 2. STANDARD MODE (if applicable)
        // this.createCard('STANDARD', 'standard'); // Deprecated view? Maybe keep it for "Mixed" score?

        const unlockedGames = gamesList.filter(game => {
            return this.engine.authManager.isGameUnlocked(game.class.name) || game.name === 'Tap';
        });

        unlockedGames.forEach(game => {
            this.createCard(this.engine.getLocalizedGameName(game), game.name);
        });
    }

    createCard(title, key, options = {}) {
        const card = document.createElement('div');
        card.className = 'game-card';
        card.dataset.searchLabel = title.toLowerCase();

        const titleDiv = document.createElement('div');
        titleDiv.className = 'game-card-title';
        const { leadIconHtml } = options;
        if (leadIconHtml) {
            const row = document.createElement('span');
            row.style.display = 'inline-flex';
            row.style.alignItems = 'center';
            row.style.gap = '10px';
            const iconWrap = document.createElement('span');
            iconWrap.style.filter = 'drop-shadow(0 0 5px var(--accent-color))';
            iconWrap.style.lineHeight = '0';
            iconWrap.innerHTML = leadIconHtml;
            const text = document.createElement('span');
            text.textContent = title;
            row.appendChild(iconWrap);
            row.appendChild(text);
            titleDiv.appendChild(row);
        } else {
            titleDiv.textContent = title;
        }
        card.appendChild(titleDiv);

        this.getHighScores(key).then(scores => {
            if (scores.length > 0) {
                const top = scores[0];
                const badge = document.createElement('div');
                badge.className = 'highscore-badge';
                badge.textContent = `${this.engine.i18n.t('leaderboard.top')}: ${top.name} (${top.score})`;
                badge.style.fontSize = '0.7rem';
                badge.style.color = 'var(--accent-color)';
                badge.style.marginTop = '5px';
                card.appendChild(badge);
            }
        });

        card.addEventListener('click', () => {
            this.showSpecificLeaderboard(title, key);
        });

        this.ui.list.appendChild(card);
    }

    filterLeaderboard(query) {
        const term = query.toLowerCase();
        if (this.ui.list.style.display === 'block') return;

        const cards = this.ui.list.querySelectorAll('.game-card');
        cards.forEach(card => {
            const title = (card.dataset.searchLabel
                || card.querySelector('.game-card-title')?.textContent
                || '').toLowerCase();
            if (title.includes(term)) {
                card.style.display = 'flex';
            } else {
                card.style.display = 'none';
            }
        });
    }

    showSpecificLeaderboard(title, key) {
        if (!this.ui.list) return;
        this.ui.list.style.display = 'block';
        this.ui.list.innerHTML = `<h3>${title}</h3><p style="text-align:center">${this.engine.i18n.t('common.loading')}</p>`;

        this.getHighScores(key).then(scores => {
            this.ui.list.innerHTML = `<h3>${title}</h3>`;
            if (scores.length === 0) {
                this.ui.list.innerHTML += `<p style="text-align:center">${this.engine.i18n.t('leaderboard.noScores')}</p>`;
            } else {
                scores.forEach((entry, index) => {
                    const row = document.createElement('div');
                    row.style.padding = '10px';
                    row.style.borderBottom = '1px solid #333';
                    row.style.fontSize = '1.2rem';
                    let nameHtml = `<span>${index + 1}. ${entry.name}</span>`;
                    if (entry.promotionLink) {
                        nameHtml = `<a href="${entry.promotionLink.startsWith('http') ? entry.promotionLink : 'https://' + entry.promotionLink}" target="_blank" style="color: var(--primary-color); text-decoration: underline; cursor: pointer;">${index + 1}. ${entry.name}</a>`;
                    }

                    row.innerHTML = `${nameHtml} <span>${entry.score}</span>`;
                    this.ui.list.appendChild(row);
                });
            }
            this._addBackButtonLogic();
        });
    }

    _addBackButtonLogic() {
        const backBtn = this.ui.backBtn;
        if (backBtn) {
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            this.ui.backBtn = newBackBtn;

            newBackBtn.addEventListener('click', () => {
                this.renderGameList(this.engine.gamesList);
                const mainBackBtn = newBackBtn.cloneNode(true);
                newBackBtn.parentNode.replaceChild(mainBackBtn, newBackBtn);
                this.ui.backBtn = mainBackBtn;
                mainBackBtn.addEventListener('click', () => this.hideMenu());
            });
        }
    }

    showLeaderboardPreview(key, parentElement) {
        let container = document.getElementById('leaderboard-ui');
        if (!container) {
            container = document.createElement('div');
            container.id = 'leaderboard-ui';
            container.style.marginTop = '20px';
            container.style.textAlign = 'left';
            container.style.display = 'inline-block';

            const firstBtn = parentElement.querySelector('button');
            if (firstBtn && firstBtn.parentNode === parentElement) {
                parentElement.insertBefore(container, firstBtn);
            } else {
                parentElement.appendChild(container);
            }
        }

        container.innerHTML = `<h3 style="text-align: center; color: var(--primary-color);">${this.engine.i18n.t('leaderboard.previewLoading')}</h3>`;

        Promise.resolve(this.getHighScores(key)).then(scores => {
            container.innerHTML = `<h3 style="text-align: center; color: var(--primary-color);">${this.engine.i18n.t('leaderboard.singleTitle')}</h3>`;

            if (scores.length === 0) {
                container.innerHTML += `<p style="text-align:center">${this.engine.i18n.t('leaderboard.noScoresShort')}</p>`;
                return;
            }

            scores.forEach((entry, index) => {
                const row = document.createElement('div');
                row.style.marginBottom = '5px';
                row.style.fontSize = '1rem';
                row.style.display = 'flex';
                row.style.justifyContent = 'space-between';

                let nameHtml = `<span style="font-weight: bold;">${index + 1}. ${entry.name}</span>`;
                if (entry.promotionLink) {
                    nameHtml = `<a href="${entry.promotionLink.startsWith('http') ? entry.promotionLink : 'https://' + entry.promotionLink}" target="_blank" style="color: var(--primary-color); text-decoration: underline; cursor: pointer; font-weight: bold;">${index + 1}. ${entry.name}</a>`;
                }

                row.innerHTML = `${nameHtml} <span>${entry.score}</span>`;
                container.appendChild(row);
            });
        });
    }
}
